const InfoContainer = ({ title, value }) => {
    return (
        <div className="cols-span-1 flex flex-col">
            <span className="text-[#42495280] font-[500] text-[12px] leading-[12px]">{title}</span>
            <span className="font-Apparat font-[600] text-[12px] leading-[16px] mt-[4px]">{value}</span>
        </div>
    )
}
export default InfoContainer